import { Box, Stack, Tab, Tabs, Typography } from "@mui/material";
import ArchiveIcon from '@mui/icons-material/Archive';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { recycleActions } from "@common-reducers/RecycleBinReducer";
import { fetchArchivedOrDeletedData } from "@common-reducers/TaskThunks";
import { useTranslation } from "react-i18next";
import { namespace } from "@common-config/constants";

export const ArchivedOrDeletedTabsAndHeader = () => {
    const { t } = useTranslation(namespace);
    const dispatch = useAppDispatch();
    const currentTab = useAppSelector((state) => state.RecycleBinReducer.currentTab);
    const headerTexts = {
        Trash: [t('archiveDialog.trash'), t('archiveDialog.trashDescription'),
        t('archiveDialog.trashWarning')],
        Archive: [t('archiveDialog.archive'), t('archiveDialog.archiveDescription'),
        t('archiveDialog.archiveInfo')]
    };

    const tabChange = (_event: React.SyntheticEvent, tab: 'Trash' | 'Archive') => {
        dispatch(recycleActions.setArchivedOrDeletedData([]));
        dispatch(recycleActions.setCurrentTab(tab))
        dispatch(recycleActions.setSearchText(''));
        dispatch(recycleActions.setArchivedOrDeletedBulkItems([]));
        dispatch(recycleActions.setFilters({
            type: [],
            date: '',
            board: []
        }));


        dispatch(fetchArchivedOrDeletedData({
            mode: tab,
            itemId: "",
            itemUpdatedAt: "",
            searchQuery: '',
            showLoader: true
        }));
    };

    const [title, description, description2] = headerTexts[currentTab as keyof typeof headerTexts] || [];
    return (
        <>
            <Stack direction={"row"} justifyContent={"center"}>
                <Tabs
                    value={currentTab}
                    onChange={tabChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    sx={{ background: 'var(--tasks-board-bg)' }}
                >
                    <Tab value="Trash"
                        icon={
                            <Box display="flex" alignItems="center" flexDirection="row" textTransform={"capitalize"}>
                                <DeleteIcon sx={{ marginRight: 1 }} />
                                {t('archiveDialog.trash')}
                            </Box>
                        }
                        sx={{ background: 'var(--tasks-board-bg)' }}
                    />
                    <Tab value="Archive"
                        icon={
                            <Box textTransform={"capitalize"} display="flex" alignItems="center" flexDirection="row">
                                <ArchiveIcon sx={{ marginRight: 1 }} />
                                {t('archiveDialog.archive')}
                            </Box>
                        }
                        sx={{ background: 'var(--tasks-board-bg)' }}
                    />
                </Tabs>
            </Stack>
            <Box>
                <Typography variant="h5">{title}</Typography>
                <Typography>{description}<br/>{description2}</Typography>
            </Box>
        </>
    );
}
